<template>
  <v-app>
    <v-app-bar
      app
      color="#48306E"
      dark
      height="110"
      id="appbar"
      elevation="0"
      hide-on-scroll
      

    >
      <v-container fluid class="py-0 px-0" >
        <v-row justify="center" justify-sm="end"   >
          
        
          <v-col cols="auto" >
            <router-link to="/escalacion"><span class="small-size"> ESCALACIÓN</span>  <v-img class="d-inline-block ml-1 mr-0 mx-sm-2" src="@/assets/img/escalacion.svg" width="15" style="vertical-align: middle;"></v-img><span class="titulos-size   d-inline-block mx-1 mx-sm-3 ">|</span> </router-link>
            <router-link to="/escalacion" ><span class="small-size"> TELÉFONO</span>  <v-img class="d-inline-block ml-1 mr-0 mx-sm-2" src="@/assets/img/telefono-blanco.svg" width="15" style="vertical-align: middle;"></v-img> <span class="titulos-size  d-inline-block mx-1 mx-sm-3">|</span></router-link>
            <router-link to="/escalacion"><span class="small-size">CORREO</span>  <v-img class="d-inline-block  ml-1  mr-3 mx-sm-2" src="@/assets/img/mail.svg" width="15" style="vertical-align: middle;" ></v-img><span class="titulos-size  d-none d-sm-inline-block mx-2 mx-sm-3">|</span></router-link>
            <a :href="'https://nncms.actstudio.xyz/storage/uploads'+aviso.Pdf.path" target="_blank" class="small-size d-none  d-sm-inline-block mr-8 ml-4" style="padding:0; color: #FFF; text-decoration:underline">Respuesta COVID-19</a>
            
            <div class="radio d-inline-block" style="vertical-align: middle;">
              <router-link to="/" @click="handleLanguage('en')">
                <span class="small-size d-inline-block ml-2 mr-1"> ENG /</span>  
              </router-link>
              <router-link to="/">
                <span class="small-size d-inline-block mr-2 ml-1" @click="handleLanguage('es')"> ESP</span>
              </router-link>
            </div>
          </v-col>
        </v-row>
        <v-row align="center"  style="background-color: white;">
          <v-col cols="6" sm="2" md="4">
            <router-link to="/">
              <v-img src="@/assets/img/neutralnetworks_logo.svg"  style="z-index:20;" class="header--logo"></v-img>
            </router-link>
          </v-col>
          <v-col cols="6" sm="10" md="8" class="text-right">
            
            <router-link to="/productos"><span class="single-item-size  px-sm-3  d-none d-sm-inline-block " style="color: #48306E;" >PRODUCTOS</span> </router-link>
            <router-link to="/acerca-de"><span class="single-item-size  px-sm-3     d-none d-sm-inline-block " style="color: #48306E;" >ACERCA DE</span> </router-link>
            <router-link to="/por-que-neutralNetwors"><span class="single-item-size   px-sm-3 d-none d-sm-inline-block" style="color: #48306E;" >¿POR QUÉ NEUTRAL NETWORKS?</span></router-link>
            <v-icon class="ma-0" color="#48306E" size="32"  style="z-index:20;" @click="isOpen=!isOpen">mdi-menu</v-icon>

             <div id="menu"  v-bind:class="{'open':isOpen}" class="d-none d-sm-block">
                <v-container fluid class="py-0">
              

                  <v-row  class=" color-morado" >

                    <v-col cols="5" sm="5" md="5" lg="5" class="pa-0 d-none d-md-block">
                      

                        <template v-for="(item, ser ) in servicios" >
                        <v-img :key="'servicio-'+ser" :src="'https://nncms.actstudio.xyz'+item.imagenCover.path" width="100%" height="calc(100vh - 100px)" v-show="categoriaActiva==ser" class="align-items-start align-center text-center" :contain="false"> 
                          <div class="d-flex" style="background-color: rgba(92, 39, 178, 0.65); height:calc(100vh - 100px);">
                            <v-row justify="center" align="center">
                            <v-col class="text-center" cols="9" md="9" lg="9">
                              <div style="">
                                <span class="enfasis-size  bold d-block mb-4">{{item.name}}</span>
                                <span class="titulos-size bold d-block">{{item.subtitle}}</span>
                              </div>
                            </v-col>
                          </v-row>
                          </div>
                        </v-img>
                        </template>
                      
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6" class="text-start  " style="color: #48306E;"> 
                      
                      <v-row  justify="start"  justify-sm="end" justify-md="center">
                        <v-col cols="5" sm="6" md="5" class="pl-sm-16 py-sm-13 ">
                          <span class="titulos-size bold d-block   mb-md-4">Productos</span>
                      
                          <router-link :to="'/servicios/'+servicio.url" v-for="(servicio,s) in servicios"  class="single-item-size  d-block my-1" @mouseover.native="categoriaActiva=s" @mouseout.native="categoriaActiva=null" :key="s" v-bind:class="{'bold': categoriaActiva==s}" style="color: #48306E;">{{servicio.name}} </router-link>

                          <span class="titulos-size bold d-block mt-4 mb-2">Nosotros</span>
                          
                          <router-link to="/"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Inicio</span></router-link>
                          <router-link to="/acerca-de"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Acerca de </span></router-link>
                          <router-link to="/por-que-neutralNetwors"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">¿Por qué Neutral Networks?</span> </router-link>
                          <router-link to="/academy"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Neutral Networks Academy</span></router-link>
                          <router-link to="/blog"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Noticias</span></router-link>
                          <router-link to="/contacto"> <span class="single-item-size  d-block my-1 my-md-1  my-lg-1" style="color: #48306E;">Contacto</span> </router-link>

                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" class="py-sm-13">
                          <span class="titulos-size bold d-block mb-md-4 mb-lg-6">Líneas de atención</span>
                      
                          
                          
                          <v-img src="@/assets/img/telefonos-nn-1.svg" width="18" class="d-inline-block mr-2 mr-md-2 mr-lg-2" ></v-img>
                          <span class="single-item-size  d-inline-block mb-md-5 mb-lg-5">(81) 1969 6670</span>
      
                          <div class="d-block"></div>
                          
                          <v-img src="@/assets/img/mensaje.jpg" width="18" class="d-inline-block pr-1 pr-md-0 pr-lg-1" ></v-img>
                          <span class="single-item-size d-inline-block mb-3 pl-1">comercial@neutralnetworks.mx</span>

                          <span class="single-item-size bold d-block">Dirección</span>
                          <span class="single-item-size  d-block">Jiménez 490 Colonia Centro</span>
                          <span class="single-item-size  d-block mb-3">Monterrey Nuevo Léon CP. 64000</span>
                          
                          <span class="single-item-size bold d-inline-block mr-2">Siguenos en: </span>
                          <!-- <v-img src="@/assets/img/linkedin-morado.svg" width="20" class="d-inline-block mb-3 mr-2 mr-md-2 mr-lg-2 fill-morado"></v-img> -->
                          <v-avatar>
                            <v-icon color="#5C27B2">mdi-linkedin</v-icon>
                          </v-avatar>
                          
                          <span class="single-item-size  d-block mt-6 mb-4 bold">Solicita más información: </span>
                          
                          <router-link to="/duenos-y-arrendadores"><span class="single-item-size  color-morado d-block my-1 my-md-1 my-lg-1">Dueño de Activos y Arrendadores </span> </router-link>
                          <router-link to="/renta-servicios"><span class="single-item-size  color-morado d-block my-1 my-md-1 my-lg-1">Renta de Servicios </span></router-link>
                          

                        </v-col>

                        <v-col cols="11" class="pt-12">
                          <v-img src="@/assets/img/an-evengroup-company_logo-morado.svg" width="150"></v-img>
                          <span class="small-size">
                            © Neutral Networks todos los derechos reservados | <router-link class="color-morado" to="/aviso-de-privacidad" >  <span class="color-morado"> Aviso de privacidad</span></router-link> | <router-link class="color-morado" to="/codigo-de-practicas-comerciales"><span class="color-morado"> Código de Prácticas Comerciales</span> </router-link>
                          </span>                        

                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  
                </v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-content>
      <div  v-bind:class="{'d-none':isOpen} " class="d-sm-block">
        <router-view>
        </router-view>
        
      </div>
      <div  id="mobileAppBar" v-bind:class="{'open':isOpen, 'd-flex':isOpen}"  class="d-none d-sm-none">
        <v-container fluid class="py-0">
                  <v-row  class="color-morado">
                    <v-col cols="12" sm="6" md="6" lg="6" class="text-start  " style="color: #48306E;"> 
                      
                      <v-row  justify="start" justify-sm="center " >
                        <v-col cols="12" class="pl-8">
                          <span class="titulos-size bold d-block   mb-md-4">Productos</span>
                      
                          <router-link :to="'/servicios/'+servicio.url" v-for="(servicio,s) in servicios"  class="single-item-size  d-block my-1" @mouseover.native="categoriaActiva=s" @mouseout.native="categoriaActiva=null" :key="s" v-bind:class="{'bold': categoriaActiva==s}" style="color: #48306E;">{{servicio.name}} </router-link>

                          <span class="titulos-size bold d-block mt-4 mb-2">Nosotros</span>
                          
                          <router-link to="/"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Inicio</span></router-link>
                          <router-link to="/acerca-de"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Acerca de </span></router-link>
                          <router-link to="/por-que-neutralNetwors"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">¿Por qué Neutral Networks?</span> </router-link>
                          <router-link to="/academy"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Neutral Networks Academy</span></router-link>
                          <router-link to="/blog"> <span class="single-item-size  d-block my-1 my-md-1 my-lg-1" style="color: #48306E;">Noticias</span></router-link>
                          <router-link to="/contacto"> <span class="single-item-size  d-block my-1 my-md-1  my-lg-1" style="color: #48306E;">Contacto</span> </router-link>

                        </v-col>
                        <v-col cols="12" class="pl-8">
                          <span class="titulos-size bold d-block  mb-4 mb-lg-6">Líneas de atención</span>
                      
                          <v-img src="@/assets/img/telefonos-nn-1.svg" width="18" class="d-inline-block mr-2 mr-md-2 mr-lg-2" ></v-img>
                          <span class="single-item-size  d-inline-block mb-md-5 mb-lg-5">(81) 1969 6670</span>
      
                          <div class="d-block"></div>
                          
                          <v-img src="@/assets/img/mensaje.jpg" width="18" class="d-inline-block pr-1  " ></v-img>
                          <span class="single-item-size d-inline-block mb-3 ml-1">comercial@neutralnetworks.mx</span>

                          <span class="single-item-size bold d-block">Dirección</span>
                          <span class="single-item-size  d-block">Jiménez 490 Colonia Centro</span>
                          <span class="single-item-size  d-block mb-3">Monterrey Nuevo Léon CP. 64000</span>
                          
                          <span class="single-item-size bold d-inline-block mr-2">Siguenos en: </span>
                          <v-avatar>
                            <v-icon color="#5C27B2">mdi-linkedin</v-icon>
                          </v-avatar>
                          
                          <span class="single-item-size  d-block mt-6 mb-4 bold">Solicita más información: </span>
                          
                          <router-link to="/duenos-y-arrendadores"><span class="single-item-size  color-morado d-block my-1 my-md-1 my-lg-1">Dueño de Activos y Arrendadores </span> </router-link>
                          <router-link to="/renta-servicios"><span class="single-item-size  color-morado d-block my-1 my-md-1 my-lg-1">Renta de Servicios </span></router-link>
                          

                        </v-col>

                        
                      </v-row>

                      <v-row justify="center" >
                        <v-col cols="11" class="pt-10 pt-md-0 text-center" >
                          <v-img src="@/assets/img/an-evengroup-company_logo-morado.svg" width="173" class="ml-16" ></v-img>
                          <span class="small-size">
                            © Neutral Networks todos los derechos reservados | <router-link class="color-morado" to="/aviso-de-privacidad" >  <span class="color-morado"> Aviso de privacidad</span></router-link> | <router-link class="color-morado" to="/codigo-de-practicas-comerciales"><span class="color-morado"> Código de Prácticas Comerciales</span> </router-link>
                          </span>                        

                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  
                </v-container>
        
      </div>
    </v-content>

    <v-footer
      dark
      color="#5C27B2"
      v-show="!isOpen"
    >
      <v-container>
        <v-row class="my-6">
          <v-col>
            <v-img src="@/assets/img/neutralnetworks_blanco.svg" width="195"></v-img>
          </v-col>
        </v-row>
        <v-row class="d-none d-sm-flex">
          <v-col cols="3">
            <span class="montserrat bold titulos-size">Contacto</span>
          </v-col>
          <v-col cols="3">
            <span class="montserrat bold titulos-size">Productos</span>
          </v-col>
          <v-col cols="3">
            <span class="montserrat bold titulos-size">Secciones</span>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col cols="12" sm="3">
            <span class="montserrat bold titulos-size d-sm-none">Contacto</span>
            <span class="d-block montserrat single-item-size">(81) 1969 6670</span>
            <span class="d-block montserrat single-item-size">comercial@neutralnetworks.mx</span>


            <span class="d-block montserrat single-item-size mt-10">Suscribete a nuestro Newsletter</span>
            <v-row >
              <v-col cols="auto" sm="6" class="px-0">
                
                <v-text-field  label="Correo Electrónico" outlined dense filled :rounded="false" :shaped="false"></v-text-field>
                
              </v-col>
              <v-col cols="auto"  sm="6" class="px-0">
                <v-btn width="30" height="40" color="#C3B0E2" tile>
                  <v-icon color="#5C27B2">mdi-check</v-icon>
                </v-btn>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" sm="3">
            <span class="montserrat bold titulos-size d-sm-none">Productos</span>

            
            <router-link v-for="(servicio,s) in servicios" :key="'serv-link-'+s" :to="'/servicios/'+servicio.url" class="d-block medium color-blanco none-decoration single-item-size uppercase">{{servicio.name}}</router-link>
            
          </v-col>
          <v-col cols="12" sm="3">
            <span class="montserrat bold titulos-size d-sm-none">Secciones</span>
            <router-link to="/" class="d-block color-blanco none-decoration single-item-size">Inicio</router-link>
            <router-link to="/acerca-de" class="d-block color-blanco none-decoration single-item-size">Acerca de</router-link>
            <router-link to="/por-que-neutralNetwors" class="d-block color-blanco none-decoration single-item-size">¿Por qué Neutral Networks?</router-link>
          </v-col>
          <v-col cols="12" sm="3">
            <router-link to="/" class="d-block color-blanco none-decoration single-item-size bold">Solicita más información</router-link>
            <router-link to="/renta-servicios" class="d-block color-blanco none-decoration single-item-size">Renta de Servicios</router-link>
            <router-link to="/duenos-y-arrendadores" class="d-block color-blanco none-decoration single-item-size">Dueños de Activos y Arrendadores</router-link>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-img src="@/assets/an-evengroup-company_logo-blanco.svg" width="182"></v-img>
          </v-col>
          <v-col cols="12">
            <span class="small-size">
              © Neutral Networks todos los derechos reservados | <router-link class="color-blanco" to="/aviso-de-privacidad">Aviso de privacidad</router-link> | <router-link class="color-blanco" to="/codigo-de-practicas-comerciales">Código de Prácticas Comerciales</router-link>
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>



export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
    isOpen:false,
    categoriaActiva:0,    
    servicios:{},
    scroll:0,

    aviso:{
      
        Pdf:{
          path:''
        }
      
    }
  }),
  mounted: function(){
    fetch('https://nncms.actstudio.xyz/api/singletons/get/AvisoPrivacidad?token=8cf7ca41761951fdde0c1e2cfda401')
    .then(data => data.json())
    .then(data => this.aviso = data);

    fetch('https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401', {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        filter: {activo:true},
        sort: {_o:1},

    })
  })
.then(res=>res.json())
.then(res => this.servicios=res.entries);

  },
  methods:{
    handleLanguage(lang){
      localStorage.setItem('lang', lang);
      window.location.reload();
    }

  },
  watch: {
    $route(to, from) {
      to;
      from;
      this.isOpen = false;
    }
  }
};
</script>
